const LoadingView: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="relative">
        {/* Outer ring */}
        <div className="w-12 h-12 rounded-full border-2 border-gallery-200"></div>
        {/* Animated arc */}
        <div className="absolute inset-0 w-12 h-12 rounded-full border-2 border-transparent border-t-gallery-800 animate-spin"></div>
      </div>
      <p className="mt-6 text-sm text-gallery-500 tracking-wide">Loading</p>
    </div>
  );
};

export default LoadingView;
